import React, { useState } from 'react';
import { Badge, Button, Card, Container, Input, Select, Stack, Text, Textarea } from '../ui';

/**
 * UIDemo
 *
 * Internal “kitchen sink” page to quickly preview core UI primitives.
 * This route should be gated behind `REACT_APP_FEATURE_UI_DEMO=1`.
 */
export default function UIDemo() {
  const [name, setName] = useState('');
  const [role, setRole] = useState('owner');
  const [notes, setNotes] = useState('');

  return (
    <div style={{ padding: '32px 0' }}>
      <Container>
        <Stack gap={20}>
          <Stack gap={6}>
            <Text as="h1" size="xl" weight={800}>UI Demo</Text>
            <Text muted>
              Preview of ProVault SPA primitives. Enable via <code>REACT_APP_FEATURE_UI_DEMO=1</code>.
            </Text>
          </Stack>

          <Card>
            <Stack gap={16}>
              <Stack direction="row" gap={12} align="center" justify="space-between" wrap="wrap">
                <Stack gap={6}>
                  <Text as="h2" size="lg" weight={700}>Buttons</Text>
                  <Text size="sm" muted>Primary / secondary / sidebar (active)</Text>
                </Stack>
                <Badge>v0</Badge>
              </Stack>

              <Stack direction="row" gap={12} align="center" wrap="wrap">
                <Button variant="primary" onClick={() => alert('Primary clicked')}>Primary</Button>
                <Button variant="secondary" onClick={() => alert('Secondary clicked')}>Secondary</Button>
                <div style={{ width: 220 }}>
                  <Button variant="sidebar" active onClick={() => alert('Sidebar clicked')}>Sidebar active</Button>
                </div>
              </Stack>
            </Stack>
          </Card>

          <Card>
            <Stack gap={16}>
              <Text as="h2" size="lg" weight={700}>Form controls</Text>
              <Stack gap={12}>
                <Input
                  label="Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Jane Doe"
                  hint="This is just demo state; it isn’t saved."
                />
                <Select label="Context" value={role} onChange={(e) => setRole(e.target.value)}>
                  <option value="owner">Owner</option>
                  <option value="nominee">Nominee</option>
                </Select>
                <Textarea
                  label="Notes"
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                  placeholder="Some notes…"
                />
              </Stack>
            </Stack>
          </Card>
        </Stack>
      </Container>
    </div>
  );
}

